import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Visible breadcrumb trail. Pair with BreadcrumbList JSON-LD (data/site breadcrumbLd)
 * so Google can render breadcrumb rich results. Last item is the current page.
 */
export default function Breadcrumbs({ items, dark = false }) {
  const linkCls = dark ? "text-stone-400 hover:text-white" : "text-stone-500 hover:text-red-600";
  const currentCls = dark ? "text-stone-200" : "text-stone-900";
  const sepCls = dark ? "text-stone-600" : "text-stone-400";
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-[11px] uppercase tracking-[0.14em] font-bold">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-1.5 max-w-full">
              {last ? (
                <span className={`${currentCls} truncate max-w-[240px]`} aria-current="page" data-testid="breadcrumb-current">
                  {it.name}
                </span>
              ) : (
                <Link to={it.path} className={`${linkCls} transition-colors`} data-testid={`breadcrumb-link-${i}`}>
                  {it.name}
                </Link>
              )}
              {!last && <ChevronRight size={12} className={sepCls} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
